<template>
  <div :class="[this.$route.path=='/'?'row-8':'row-9','positionRE']" v-if="$store.state.webNavigator == 'pc'">
    <div :class="[this.$route.path=='/'?'buttons':'bottomOll']">
      <div class="deep-line">
        <div class="footer-box">
          <div class="footer-box-title">关于我们</div>
          <div class="feed">
            <a
              v-for="(item, index) in secondTypeList1"
              :href="item.hrefs"
              :key="index"
            >{{ item.name }}</a
            >
          </div>
          <div class="feed">
            <a
              v-for="(item, index) in secondTypeList2"
              :href="item.hrefs"
              :key="index"
            >{{ item.name }}</a
            >
          </div>
        </div>
        <div
          v-for="(item, index) in endlist"
          :key="index"
          :class="
            index == endlist.length - 1 ? 'footer-last-box' : 'footer-box'
          "
          v-if="item.name.indexOf('知识') > -1"
        >
          <div class="footer-box-title" @click="path(item)">
            {{ item.name }}
          </div>
          <div class="feed">
            <div
              class="link-name"
              @click="path2(item1, item, index)"
              :key="index"
              v-for="(item1, index) in item.data"
              v-if="index <= 2"
            >
              {{ item1.text }}
            </div>
          </div>
        </div>
        <div class="footer-box-title">合作伙伴</div>
        <div class="feed">
          <a
            v-for="(item, index) in secondTypeList3"
            :href="item.hrefs"
            :key="index"
          >{{ item.name }}</a
          >
        </div>
      </div>
      <div class="friendLink" v-show="this.$route.path=='/'">
        <div class="footer-box-title">友情链接：</div>
        <!-- <a href="https://www.zmelo.com/InformationList/60-0-1-tizhiguanli.html" class="linkstyle">体质管理</a>
        <a href="https://www.zmelo.com/InformationList/61-1-1-yingyangguanli.html" class="linkstyle">营养管理</a>
        <a href="https://www.zmelo.com/InformationList/62-2-1-zuoxiguanli.html" class="linkstyle">作息管理</a>
        <a href="https://www.zmelo.com/InformationList/62-2-1-zuoxiguanli.html" class="linkstyle">作息管理</a> -->
        <!-- <a href="https://www.gooeto.cn/ " class="linkstyle">谷医堂</a> -->
        <a href="https://www.gufangyiyuan.cn/" class="linkstyle">谷方益元</a>
        <a href="http://www.zetanmijia.cn/" class="linkstyle">正糖名家</a>
        <a href="https://www.renshen365.com" class="linkstyle">长白山人参</a>
        <a href="https://www.meidouya.com" class="linkstyle">健康养生</a>
        <a href="http://www.rrjkw.net" class="linkstyle">人人健康</a>
        <!--          <a href="https://www.perfectshape.com.cn/" class="linkstyle">祛斑</a>-->
        <a href="http://www.rzebhkyy.com/" class="linkstyle">山东省耳鼻喉医院</a>
        <a href="http://jianfei99.cn" class="linkstyle">减肥网</a>    <a href="http://www.skrd168.com" class="linkstyle">尿碘检测仪</a>
<!--        <a href="https://www.lfcm888.com" class="linkstyle">女性健康网</a>-->

<!--        <a href="http://www.0724aier.com" class="linkstyle">荆门爱尔眼科医院</a>-->
      </div>
    </div>
    <div class="deep-line2 flexSpace">
      <div class="code2">
        <img :src="src" title="" alt=""/>
        <div class="code2-content">扫码关注脂玫乐公众号</div>
      </div>
      <div class="code2">
        <img :src="src1" title="" alt=""/>
        <div class="code2-content">扫描下载脂玫乐app</div>
      </div>
      <div class="address flexStart">
        <img :src="src2" title="" class="displayIB address-img"/>
        <div class="displayIB">
          <div class="address-content">湖南省长沙市高新开发区汇智中路179号</div>
          <div class="address-content">金荣同心工业园C6栋</div>
        </div>
      </div>
      <div class="phone-number flexStart">
        <img :src="src3" title="" class="phone-number-img"/>
        <div class="phone-number-content">400-8855-091</div>
      </div>
      <img :src="src4" title="" class="code"/>
      <div class="share">
        <div class="d-hover positionRE">
          <div class="code-item hsItem"></div>
          <img :src="src5" title="" class="code-item-big positionAB"/>
        </div>
        <div class="d-hover positionRE">
          <div class="code-item dyItem"></div>
          <img :src="src6" title="" class="code-item-big positionAB"/>
        </div>
        <div class="d-hover">
          <a
            class="code-item ttItem"
            rel="external nofollow"
            href="https://www.toutiao.com/c/user/619748942939964/#mid=1627878775647236"
          >
          </a>
        </div>
        <div class="d-hover">
          <a
            class="wbItem"
            rel="external nofollow"
            href="https://weibo.com/u/6259280293"
          >
          </a>
        </div>
      </div>
    </div>
    <div class="bottom-copy">
      <a
        style="color: #fff"
        rel="external nofollow"
        href="https://beian.miit.gov.cn/#/Integrated/index"
      >湘ICP备17011020号-3</a
      >
    </div>
  </div>
  <div v-else>
    <div class="phone-fotNav">
      <div class="fotNav-Box">
        <div class="fotNav-topBox">
          <div
            v-for="(item, index) in navList"
            :key="index"
            class="fotNav-ListBox"
          >
            <div class="fotNav-Tlt" @click="goNav(item, index)">
              {{ item.name }}
            </div>
            <div class="fotNav-ListP">
              <div
                v-for="(item2, index2) in item.children"
                :key="index2"
                class="fotNav-P"
                @click="goNav(item2, index2)"
              >
                {{ item2.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="fotNav-topBoxloge">
          <div @click="downloadApp(1)" class="min-box">
            <img
              style="width: 100%; height: 100%"
              :src="phone1"
              title=""
              alt=""
            />
          </div>
          <div @click="downloadApp(2)" class="min-box">
            <img
              style="width: 100%; height: 100%"
              :src="phone2"
              title=""
              alt=""
            />
          </div>
          <div @click="downloadApp(3)" class="min-box">
            <img
              style="width: 100%; height: 100%"
              :src="phone3"
              title=""
              alt=""
            />
          </div>
          <div @click="downloadApp(4)" class="min-box">
            <img
              style="width: 100%; height: 100%"
              :src="phone4"
              title=""
              alt=""
            />
          </div>
        </div>
        <div class="fotNav-fotBox">
          <div class="fotNav2-ewmBox">
            <img
              class="fotNav2-ewm"
              :src="phone5"
              title=""
              alt="扫码关注脂玫乐公众号"
            />
            <p class="colffffff font17phone fotNav2-ewmP">
              扫码关注 <br/>脂玫乐公众号
            </p>
          </div>
          <div class="fotNav2-TextBox colffffff displayIB">
            <div class="font20phone">
              <span class="fotNav2-map"></span>
              <div class="displayIB fotNav2-Text">
                湖南省长沙市高新开发区汇智中路179 号金荣同心工业园C6栋
              </div>
            </div>
            <div class="font36phone fontWeightB">
              <span class="fotNav2-phone"></span>
              <div class="fotNav2-Text2 displayIB">400-8855-091</div>
            </div>
          </div>
        </div>
      </div>
      <div class="friendLink" v-show="this.$route.path=='/'">
        <div class="footer-box-title1">友情链接：</div>
        <!-- <a href="https://www.zmelo.com/InformationList/60-0-1-tizhiguanli.html" class="linkstyle">体质管理</a>
        <a href="https://www.zmelo.com/InformationList/61-1-1-yingyangguanli.html" class="linkstyle">营养管理</a>
        <a href="https://www.zmelo.com/InformationList/62-2-1-zuoxiguanli.html" class="linkstyle">作息管理</a>
        <a href="https://www.zmelo.com/InformationList/62-2-1-zuoxiguanli.html" class="linkstyle">作息管理</a> -->
        <!-- <a href="https://www.gooeto.cn/ " class="linkstyle">谷医堂</a> -->
        <div class="aLink">
          <a href="https://www.gufangyiyuan.cn/" class="linkstyle">谷方益元</a>
          <a href="http://www.zetanmijia.cn/" class="linkstyle">正糖名家</a>
          <a href="https://www.renshen365.com" class="linkstyle">长白山人参</a>
          <a href="https://www.meidouya.com" class="linkstyle">健康养生</a>
          <a href="http://www.rrjkw.net" class="linkstyle">人人健康</a>
          <!--          <a href="https://www.perfectshape.com.cn/" class="linkstyle">祛斑</a>-->
          <a href="http://www.rzebhkyy.com/" class="linkstyle">山东省耳鼻喉医院</a>
          <a href="http://jianfei99.cn" class="linkstyle">减肥网</a>
          <a href="http://www.skrd168.com" class="linkstyle">尿碘检测仪</a>
<!--          <a href="https://www.lfcm888.com" class="linkstyle">女性健康网</a>-->

<!--          <a href="http://www.0724aier.com" class="linkstyle">荆门爱尔眼科医院</a>-->
        </div>
      </div>
    </div>

    <div class="fotNav2-copyright">
      <a
        class="col99999 font16phone"
        rel="external nofollow"
        href="http://www.beian.miit.gov.cn/"
      >湘ICP备17011020号-3</a>
    </div>
  </div>
</template>

<script>
import {myFun, } from '../../plug/modifyImagePath';
import {$get, } from '../../others/ajax';
import config from '@/others/interface';

export default {
  name: 'FooterNavigation',
  data () {
    return {
      endlist: [],
      secondTypeList1: [
        {
          name: '联系我们',
          hrefs: '/about/lianxiwomen.html',
        },
        // {
        //   name: '案例视频',
        //   hrefs: '/caseVideo/0-1-anlishipin.html',
        // },
        // {
        //   name: '案例分享',
        //   hrefs: '/caseSharing/1-1-anlifenxiang.html',
        // },
      ],
      secondTypeList2: [
        {
          name: '关于产品',
          hrefs: '/aboutProducts/guanyuchanpin.html',
        },
        {
          name: '防伪查询',
          hrefs: '/search/fangweichaxun.html',
        },
      ],
      secondTypeList3: [
        {
          name: '湖南省中医药研究院',
          hrefs: '#',
        },
        {
          name: '湖南中医药大学',
          hrefs: '#',
        },
        {
          name: '红网',
          hrefs: '#',
        },
      ],
      navList: [
        {
          name: '关于我们',
          hrefs: '/about/guanyuwomen.html',
          children: [
            // {
            //   name: '减肥案例',
            //   hrefs: '/caseVideo/0-1-jianfeianli.html',
            // },
            {
              name: '关于产品',
              hrefs: '/aboutProducts/guanyuchanpin.html',
            },
            {
              name: '防伪查询',
              hrefs: '/search/fangweichaxun.html',
            },
            {
              name: '联系我们',
              hrefs: '/about/lianxiwomen.html',
            },
          ],
        },
        {
          name: '减肥知识',
          hrefs: '',
          children: [],
        },
        {
          name: '合作伙伴',
          hrefs: '',
          children: [
            {
              name: '湖南省中医药研究院',
              hrefs: '',
            },
            {
              name: '湖南中医药大学',
              hrefs: '',
            },
            {
              name: '红网',
              hrefs: '',
            },
          ],
        },
      ], // 手机导航列表
      src: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/wxewm.png'
      ),
      src1: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/download.png'
      ),
      src2: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/address.png'
      ),
      src3: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/phone.png'
      ),
      src4: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/demoncode.png'
      ),
      src5: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/huoshancode.png'
      ),
      src6: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/douyingcode.png'
      ),
      phone1: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/04b0092fc7ba4992b10727335734cd9d%402x.png'
      ),
      phone2: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/0b0d00034f403420fe3341bb3c386697%402x.png'
      ),
      phone3: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/607bd146c2e04f98900fe0f210f6acda%402x.png'
      ),
      phone4: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/73f98872ee124196b7e5769ab5b1f0ea%402x.png'
      ),
      phone5: myFun(
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/ewm/zmlfotewm.png'
      ),
    };
  },
  methods: {
    downloadApp (a) {
      if (a == 1) {
        window.open(
          'https://share.huoshan.com/pages/user/index.html?to_user_id=MS4wLjABAAAAhpfch3rexG-J2SYBkZx_EpiWtvKjY5n7ZHNnACttsPs0RzqfGIQTDrzaMeeLuJ6R&timestamp=1602815364&share_ht_uid=1481773820939068&did=70012810433&iid=1143109811962400&utm_medium=huoshan_android&tt_from=copy_link&app=live_stream&utm_source=copy_link&schema_url=sslocal%3A%2F%2Fprofile%3Fid%3D1481773820939068',
          '_blank'
        );
      } else if (a == 2) {
        window.open(
          'https://www.iesdouyin.com/share/user/96887620776?u_code=15ab4il53&sec_uid=MS4wLjABAAAAF6CFqbnOq5u7OsuXuAIUSCBg21aX714Xbeamh26r7qs&timestamp=1602815707&utm_source=copy&utm_campaign=client_share&utm_medium=android&share_app_name=douyin',
          '_blank'
        );
      } else if (a == 3) {
        window.open(
          'https://profile.zjurl.cn/rogue/ugc/profile/?user_id=619748942939964&media_id=1627878775647236&request_source=1#mid=1627878775647236',
          '_blank'
        );
      } else {
        window.open(
          'https://passport.weibo.com/visitor/visitor?entry=miniblog&a=enter&url=https%3A%2F%2Fweibo.com%2FwujingJK%3Fis_all%3D1&domain=.weibo.com&ua=php-sso_sdk_client-0.6.36&_rand=1602829132.011',
          '_blank'
        );
      }
    },
    goSanFang (item) {
      if (item.url) {
        location.href = item.url;
      }
    }, // 去第三方平台
    goNav (item, index) {
      let helpcode = pinyinUtil.getPinyin(item.name, '', false, false);
      // if (item.parent == '瘦身百科') {
      //   this.$router.push({path: '/encyclopeDias/' + item.id + '/' + index + '/1/' + helpcode + '.html', });
      // }
      if (item.parent == '减肥知识') {
        this.$router.push({
          path:
              '/InformationList/' +
              item.id +
              '-' +
              index +
              '-1-' +
              helpcode +
              '.html',
        });
      }
      if (item.hrefs) {
        this.$router.push({path: item.hrefs, });
      }
    }, // 去一二级导航
    getEndList () {
      $get(config.zmlgw + '/web/getEndClass', {}).then((res) => {
        if (res.code == 200) {
          this.endlist = res.returnData;
          res.returnData[0].data.map((item, index) => {
            let obj = {
              name: item.text,
              id: item.id,
              parent: '减肥知识',
            };
            this.navList[1].children.push(obj);
          });
          // res.returnData[1].data.map((item, index) => {
          //   let obj = {
          //     name: item.text,
          //     id: item.id,
          //     parent: '瘦身百科',
          //   };
          //   this.navList[1].children.push(obj);
          // });
        }
      });
    },
    path (item) {
      this.$router.push({path: item.hrefs, });
    },
    path2 (item, item2, index) {
      let helpcode = pinyinUtil.getPinyin(item.name, '', false, false);
      if (item2.name == '减肥知识') {
        this.$router.push({
          path:
              '/InformationList/' +
              item.id +
              '-' +
              index +
              '-1-' +
              helpcode +
              '.html',
        });
      }
      if (item2.name == '减肥视频') {
        this.$router.push({
          path:
              '/encyclopeDias/' +
              item.id +
              '/' +
              index +
              '/1/' +
              helpcode +
              '.html',
        });
      }
    },
  },
  created () {
    this.getEndList();
  },
  watch: {},
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("./FooterNavigationPhone.less");
  }

  @media screen and (min-width: 800px) {
    @import url("./FooterNavigation.less");
  }
</style>



// WEBPACK FOOTER //
// FooterNavigation.vue